<template>
  <div>
    <Layout :pagetitle="$t('Payment by Affiliate')">
      <b-card>
        <b-row>
          <b-col class="m-2">
            <b-row>
              <div class="col-md-4">
                <label>{{ $t('Brand') }}</label>
                <brandSelectorUnique :modelValue="idBrand" @onChange="changeBrandFilter" />
              </div>
              <div class="col-md-4">
                <label>{{ $t('Users') }}</label>
                <input :placeholder="$t('Users')" class="form-control" type="number" v-model="usersCount" />
              </div>
              <div class="col-md-4">
                <label>{{ $t('Comissão') }}</label>
                <input :placeholder="$t('Comissão')" class="form-control" type="number" v-model="minReward" />
              </div>
              <div class="col-md-4 mt-2">
                <label>{{ $t('Sub Brand') }}</label>
                <subBrandsSelector
                  :mode="'single'"
                  :modelValue="idSubBrand"
                  @onChange="setSubBrand"
                  :allowEmpty="true"
                />
              </div>
              <div class="col-md-4 mt-2">
                <label>{{ $t('Data Início') }}</label>
                <input class="form-control" type="date" v-model="startDate" />
              </div>
              <div class="col-md-4 mt-2">
                <label>{{ $t('Data Fim') }}</label>
                <input class="form-control" type="date" v-model="endDate" />
              </div>
            </b-row>
            <b-row class="mt-2">
              <b-col md="5" offset="7">
                <div class="table-buttons">
                  <button class="btn-sm btn btn-success" :disabled="!report.data.length" @click="downloadXls">
                    {{ $t('Export XLS') }}
                  </button>
                  <button
                    class="ml-1 btn-sm btn btn-primary"
                    @click="showModalPayment"
                    :disabled="!report.data.length"
                  >
                    {{ $t('Pay') }}
                  </button>
                  <button
                    class="ml-1 btn-sm btn btn-primary"
                    :disabled="!idBrand || !startDate || !endDate"
                    @click="getAffiliateReport"
                  >
                    {{ $t('Buscar') }}
                  </button>
                </div>
              </b-col>
            </b-row>
          </b-col>
        </b-row>

        <b-row v-if="report.data.length">
          <b-col class="">
            <div class="card my-0 py-0 border border-primary">
              <div class="card-header bg-transparent border-primary py-0">
                <h5 class="my-0 text-primary">
                  <i :class="`fas fa-ticket-alt me-3`"></i>
                  {{ $t('Summary') }}
                </h5>
              </div>
              <div class="card-body row">
                <div class="summary-column">
                  <span class="text-muted small d-block">
                    {{ $t('Users') }}
                  </span>
                  <span class="h5">{{ report.summary.active_customers_count }}</span>
                </div>

                <div class="summary-column">
                  <span class="text-muted small d-block">
                    {{ $t('Comissão') }}
                  </span>
                  <span class="h5">{{ $utils.formatMoneyFloat(report.summary.reward_accumulative) }}</span>
                </div>

                <div class="summary-column" v-if="!hideCpa">
                  <span class="text-muted small d-block">
                    {{ $t('Qty. CPA') }}
                  </span>
                  <span class="h5">{{ report.summary.reward_mark_count }}</span>
                </div>

                <div class="summary-column" v-if="!hideCpa">
                  <span class="text-muted small d-block"> CPA </span>
                  <span class="h5">{{ $utils.formatMoneyFloat(report.summary.reward_mark) }}</span>
                </div>

                <div class="summary-column">
                  <span class="text-muted small d-block">
                    {{ $t('Valor a Pagar') }}
                  </span>
                  <span class="h5">{{ $utils.formatMoneyFloat(report.summary.reward_total) }}</span>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>

        <Table
          :key="hideCpa"
          :title="''"
          :items="report.data"
          :columns="computedColumns"
          :totalItems="report.data.length"
          :showButtons="false"
          :searchable="false"
          :editable="false"
          :removable="false"
          :showPagination="false"
          :isCard="false"
        />

        <b-modal v-model="showPaymentModal" :title="$t('Payment Resume')" size="lg" hide-footer>
          <modal-payment-affiliate
            @hide="showPaymentModal = false"
            @confirm="confirmPayment"
            v-if="showPaymentModal"
            :payment="report"
          />
        </b-modal>
      </b-card>
    </Layout>
  </div>
</template>

<script>
import Layout from '@/views/layouts/main';
import Table from '@/components/bootstrap/table';
import staticData from './staticData';
import { exportXls } from './functions';
import brandSelectorUnique from '@/components/selectors/brandSelectorUnique';
import moment from 'moment';
import ModalPaymentAffiliate from './ModalPaymentAffiliate.vue';
import subBrandsSelector from '@/components/selectors/subBrandsSelector';

export default {
  components: { Layout, Table, brandSelectorUnique, ModalPaymentAffiliate, subBrandsSelector },
  data() {
    return {
      idSubBrand: null,
      minReward: null,
      usersCount: null,
      startDate: moment(moment().format('YYYY-MM')).format('YYYY-MM-DD'),
      endDate: moment(moment().format('YYYY-MM')).add('months', 1).subtract('days', 1).format('YYYY-MM-DD'),
      idBrand: null,
      report: { data: [], summary: {} },
      columns: staticData().columns,
      showPaymentModal: false
    };
  },
  computed: {
    hideCpa() {
      this.$store.state.companySettings;
      return this.shouldHideCpa();
    },
    computedColumns() {
      let cols = staticData().columns;
      if (this.hideCpa) {
        cols = cols.filter((col) => col.key !== 'reward_mark_count' && col.key !== 'reward_mark');
      }
      return cols;
    }
  },
  methods: {
    setSubBrand(id = null) {
      this.idSubBrand = id;
    },
    confirmPayment() {
      this.$store.commit('SET_LOADING', true);
      this.$api
        .post('api/remittance', {
          idBrand: this.idBrand,
          data: {
            startDate: this.startDate,
            endDate: this.endDate,
            usersCount: this.usersCount,
            minReward: this.minReward,
            idSubBrand: this.idSubBrand || null
          }
        })
        .then(() => {
          this.$store.commit('SET_LOADING', false);
          this.$customAlert({
            type: 'success',
            msg: this.$t('Success')
          });
          this.showPaymentModal = false;

          this.$store.commit('SET_PARAMS', { currentMonth: moment().format('YYYY-MM'), idBrand: this.idBrand });

          this.$router.push({
            name: 'AffiliateEntries'
          });
        })
        .catch((err) => {
          this.$store.commit('SET_LOADING', false);
          this.$customAlert({
            type: 'error',
            msg: err?.response?.data?.message || this.$t('Erro ao realizar pagamento')
          });
        });
    },
    showModalPayment() {
      this.showPaymentModal = true;
    },
    getAffiliateReport() {
      this.$store.commit('SET_LOADING', true);

      let payload = {
        idBrand: this.idBrand,
        startDate: this.startDate,
        endDate: this.endDate,
        usersCount: this.usersCount,
        minReward: this.minReward
      };

      if (this.idSubBrand) {
        payload['idSubBrand'] = this.idSubBrand;
      }

      this.$api
        .get('api/affiliate/reward/report', payload)
        .then((res) => {
          this.$store.commit('SET_LOADING', false);
          this.report = res.data;
        })
        .catch((err) => {
          this.$store.commit('SET_LOADING', false);
          console.log(err);
        });
    },
    changeBrandFilter(idBrand) {
      this.idBrand = idBrand;
    },
    downloadXls() {
      this.report.summary['name'] = '';
      exportXls([...this.report.data, this.report.summary]);
    }
  }
};
</script>

<style lang="scss">
.summary-column {
  white-space: nowrap !important;
  // min-width: 150px;
  flex: 1;
}

.summary-column-sm {
  min-width: 120px;
  flex: 1;
}

.summary-column-lg {
  min-width: 180px;
  flex: 1;
}
</style>
